import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperPlane,
  faCommentArrowUpRight,
} from "@fortawesome/pro-solid-svg-icons";

const Socials = ({ email, phone }) => {
  return (
    <div className="flex gap-6 lg:items-center">
      {email && (
        <a
          href={`mailto:${email}`}
          className="flex items-center gap-2 no-underline"
        >
          <FontAwesomeIcon
            icon={faPaperPlane}
            className="w-3.5 text-primary"
          />
          <span className="text-xs font-medium text-dark-text">
            {email}
          </span>
        </a>
      )}
      {phone && (
        <a
          href={`tel:${String(phone).replace(/\D+/g, "")}`}
          className="flex items-center gap-1.5 no-underline"
        >
          <FontAwesomeIcon
            icon={faCommentArrowUpRight}
            className="w-3.5 text-primary"
          />
          <span className="text-xs font-medium text-dark-text">
            {phone}
          </span>
        </a>
      )}
    </div>
  )
}

export default Socials;